<template>
    <span v-if="mostrarBtnHistorico">
        <b-button variant="primary" @click.stop="obterHistorico()">
            <span> <i class="fa fa-calendar"></i> Histórico</span>
        </b-button>
        <b-modal v-model="mostrarModal" :cancel-disabled="true" scrollable>
            <div slot="modal-title">
                Histórico do Registro de Pagamento
            </div>
            <b-row v-for="item in historico" :key="item.dataCadastro">
                <b-col sm="12">
                    <historico-detalhe :historico="item"></historico-detalhe>
                </b-col>
            </b-row>
            <div slot="modal-footer">
                <b-button variant="primary" @click.stop="fecharModal()"
                    >Ok</b-button
                >
            </div>
        </b-modal>
    </span>
</template>

<script>
import HistoricoDetalhe from './PagamentoHistoricoDetalhe'

export default {
    components: {
        HistoricoDetalhe
    },

    props: {
        pagamento: {
            type: Object,
            default: () => ({})
        },

        pagamentosServicos: {
            type: Object,
            default: () => ({})
        }
    },

    data() {
        return {
            mostrarModal: false,
            historico: []
        }
    },

    methods: {
        abrirModal() {
            this.mostrarModal = true
        },

        fecharModal() {
            this.mostrarModal = false
        },

        obterHistorico() {
            this.$store.dispatch('addRequest')
            this.pagamentosServicos
                .obterHistorico(this.pagamento.pagamentoId)
                .then(response => {
                    if (response) {
                        if (response.success) {
                            this.historico = response.data
                            this.mostrarModal = true
                        } else {
                            this.$toast.error(
                                'Erro ao obter histórico',
                                'ERROR',
                                this.$toastConfig.error
                            )
                        }
                    }
                    this.$store.dispatch('removeRequest')
                })
        }
    },

    computed: {
        mostrarBtnHistorico() {
            return this.$temAcesso('SGTEC-UABS-PAG-04')
        }
    }
}
</script>
